const ADMIN_FLAG_KEY = "ead.systemAdmin";
const ADMIN_TOKEN_KEY = "ead.systemAdminToken";

export function isEadSystemAdmin(): boolean {
  try {
    const flag = localStorage.getItem(ADMIN_FLAG_KEY);
    if (flag === "true") return true;
    if (flag === "false") return false;
    return import.meta.env.DEV === true;
  } catch {
    return false;
  }
}

export function setEadSystemAdmin(enabled: boolean): void {
  try {
    if (enabled) {
      localStorage.setItem(ADMIN_FLAG_KEY, "true");
    } else {
      localStorage.removeItem(ADMIN_FLAG_KEY);
    }
  } catch {
    /* ignore */
  }
}

export function getEadAdminToken(): string {
  try {
    return localStorage.getItem(ADMIN_TOKEN_KEY) || "";
  } catch {
    return "";
  }
}

export function setEadAdminToken(token: string): void {
  try {
    const trimmed = token.trim();
    if (trimmed) {
      localStorage.setItem(ADMIN_TOKEN_KEY, trimmed);
    } else {
      localStorage.removeItem(ADMIN_TOKEN_KEY);
    }
  } catch {
    /* ignore */
  }
}
